import { Text } from '@avanta/shared/components/Text';
import { Dialog } from '@avanta/shared/components/ui/Dialog';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { type Appointment } from 'types/appointments';
import { useCancelAppointment } from './useCancelAppointment';

export const CancelAppointmentDialog = ({
  appointment,
}: {
  appointment: Appointment;
}): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.INSURANCE);
  const { mutate: cancelAppointment, isPending } = useCancelAppointment(appointment.id);

  const handleCancelSession = (): void => {
    cancelAppointment({
      psychologistId: appointment.psychologistId,
      appointmentId: appointment.id,
      patientId: appointment.patientId,
    });
  };

  return (
    <Dialog
      isDestructive
      title={t('CancelSessionDialog.heading')}
      secondaryAction={{
        label: (
          <>
            <X className="size-4" />
            {t('CancelSessionDialog.cancel')}
          </>
        ),
        variant: 'destructive_terciary',
        size: 'lg',
        icon: 'leading',
      }}
      primaryAction={{
        label: t('CancelSessionDialog.confirm'),
        action: handleCancelSession,
        variant: 'destructive',
        size: 'lg',
        isLoading: isPending,
      }}
      open
    >
      <Text variant="text-md-regular" className="text-denim-500">
        {t('CancelSessionDialog.body')}
      </Text>
    </Dialog>
  );
};
